import type { SVGProps } from "react";

export function IconEllipse({
  width = 9,
  height = 10,
  fill = "none",
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      fill={fill}
      height={height}
      viewBox="0 0 9 10"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="4.5" cy="5" fill="black" r="4.5" />
    </svg>
  );
}
